export const getProductHandleFromPath = (path: string | null): string | null => {
  if (!path) return null
  const match = path.match(/\/products\/([^/?#]+)/)
  return match?.[1] ?? null
}
